<app-ui-document-panel-shell
  [breadcrumb]="breadcrumb"
  [title]="panelTitle"
  [documentId]="po_no || ''"
  [statusLabel]="statusLabel"
  [statusVariant]="statusVariant"
  (closed)="onClose()">

  <app-ui-approval-stepper *ngIf="data?.id" [steps]="approvalSteps"></app-ui-approval-stepper>

  <app-ui-form-section title="General Information" icon="info">
  <div style="display: flex; justify-content: start; gap: 30px;flex-wrap: wrap; max-width: 100%;">
    <!-- <mat-slide-toggle [checked]="is_requisition" (change)="onToggleChange($event)">
      From Requisition
  </mat-slide-toggle> -->
    <div style="flex: 1;" *ngIf="is_qc" [matTooltip]="getVendorName(vendor)" [matTooltipDisabled]="!isUpdateMode">
      <mat-form-field appearance="outline" style="width: auto;">
        <mat-label>Select Vendor <span style="color: red">*</span></mat-label>
        <mat-select [(ngModel)]="vendor" placeholder="Select Vendor" (ngModelChange)="vendorBranch($event)" [disabled]="isUpdateMode">
          <mat-option *ngFor="let item of vendordata" [value]="item.vendor_id">
            {{ item.vendor_name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div> 
    <div style="flex: 1;" *ngIf="is_requisition" [matTooltip]="getVendorName(vendor)" [matTooltipDisabled]="!isUpdateMode">
      <!-- <mat-form-field appearance="outline" style="width: auto;">
        <mat-label>Select Vendor <span style="color: red">*</span></mat-label>
        <mat-select [(ngModel)]="vendor" placeholder="Select Vendor" (ngModelChange)="vendorBranch($event)" [disabled]="isUpdateMode">
          <mat-option *ngFor="let item of vendordata" [value]="item.id">
            {{ item.vendor_name }}
          </mat-option>
        </mat-select>
      </mat-form-field> -->
      <mat-form-field appearance="outline" style="width: auto;">
        <mat-label>Select Vendor <span style="color: red">*</span></mat-label>
    
        <mat-select #vendorSelect [(ngModel)]="vendor" [disabled]="this.is_approval_status === 'Open' || isInputDisabled" panelClass="vendor-select-panel"
          (openedChange)="onVendorOpen($event)" (ngModelChange)="vendorBranch($event)">
          <mat-option disabled>
            <input matInput placeholder="Search vendor..." (keyup)="onVendorSearch($event.target.value)"
              (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
          </mat-option>
          <mat-option *ngFor="let item of vendordata" [value]="item.id">
            {{ item.vendor_name }}
          </mat-option>
          <mat-option *ngIf="loadingVendor" disabled>
            Loading…
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div style="flex: 1" [matTooltip]="getBranchName(vendor_branch)" [matTooltipDisabled]="!isUpdateMode">
      <mat-form-field appearance="outline" style="width: auto;">
        <mat-label>Vendor Branch Name<span style="color: red">*</span></mat-label>
        <mat-select [(ngModel)]="vendor_branch" placeholder="Select Vendor Branch" (ngModelChange)="fetchContactPersons(vendor, vendor_branch); fetchqc(vendor,vendor_branch);" [disabled]="this.is_approval_status === 'Open' || isInputDisabled">
        <mat-option *ngFor="let branch of selectedBranch" [value]="branch.id">
          {{ branch.branch_name }}
        </mat-option>
      </mat-select>
      </mat-form-field>
    </div>
    <div style="flex: 1;" *ngIf="is_qc">
      <mat-form-field appearance="outline" style="width: auto;">
        <mat-label>Select Quotation <span style="color: red">*</span></mat-label>
        <mat-select [(ngModel)]="quotation" multiple placeholder="Select Quotation" (ngModelChange)="fetchdata($event)" [disabled]="isInputDisabled">
          <mat-option *ngFor="let item of filteredQuotations" [value]="item">
            {{ item.qc_no }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <!-- <div style="flex: 1;"> -->
      <!-- <mat-form-field appearance="outline" style="width: auto;">
            <mat-label>Branch</mat-label>
            <mat-select [(ngModel)]="branch" (ngModelChange)="fetchProfitCost(branch)">
              <mat-option *ngFor="let data of branchdata" [value]="data.id">
                {{ data.name }}
              </mat-option>
            </mat-select>
          </mat-form-field> -->
      <!-- <mat-form-field appearance="outline"> -->
    <!-- <div style="flex: 1;">
      <mat-form-field appearance="outline" style="width: auto;">
        <mat-label>Branch</mat-label>
        <mat-select [(ngModel)]="branch" (selectionChange)="onBranchChange(branch)">
          <mat-option *ngFor="let data of branchdata" [value]="data.id">
            {{ data.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div> -->
    <div style="flex: 1;" [matTooltip]="getBranchName(branch)" [matTooltipDisabled]="!isUpdateMode">
      <mat-form-field appearance="outline" style="width: auto;">
        <mat-label>Branch<span style="color: red">*</span></mat-label>
    
        <mat-select #branchSelect [(ngModel)]="branch" panelClass="branch-select-panel" [disabled]="isInputDisabled"
          (openedChange)="onBranchOpen($event)" (ngModelChange)="onBranchChange($event)">
          <mat-option disabled>
            <input matInput placeholder="Search branch..." (keyup)="onBranchSearch($event.target.value)"
              (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
          </mat-option>
          <mat-option *ngFor="let data of branchdata" [value]="data.id">
            {{ data.name }}
          </mat-option>
    
          <mat-option *ngIf="loadingBranch" disabled>
            Loading…
          </mat-option>
    
        </mat-select>
      </mat-form-field>
    </div>
    
  <!-- <div style="flex: 1;" *ngIf="is_requisition"> -->
    <!-- <mat-form-field appearance="outline" style="width: auto;"> -->
      <!-- <mat-label>Select profit/cost center <span style="color: red">*</span></mat-label> -->
      <!-- <mat-select [(ngModel)]="profitcost" placeholder="Select profit/cost center"
      (ngModelChange)="fetchSection(profitcost)" [disabled]="isUpdateMode"> 
      <mat-select [(ngModel)]="profitcost" placeholder="Select profit/cost center"
      (selectionChange)="onProfitCostChange(profitcost)">
        <mat-option *ngFor="let item of filteredProfitCost" [value]="item.id" [disabled]="item.is_active == 0">{{ item.name }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div> -->

<div style="flex: 1;" *ngIf="is_requisition">
  <mat-form-field appearance="outline" style="width: auto;">
    <mat-label>Select profit/cost center <span style="color: red">*</span></mat-label>
    <mat-select [(ngModel)]="profitcost" (selectionChange)="onProfitCostChange(profitcost)"
      (openedChange)="onProfitCostOpen($event)" [disabled]="isInputDisabled">
      <mat-option disabled>
        <input matInput placeholder="Search profit/cost center..." (keyup)="onProfitCostSearch($event.target.value)"
          (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      </mat-option>
      <mat-option *ngFor="let item of filteredProfitCost" [value]="item.id" [disabled]="item.is_active == 0">
        {{ item.name }}
      </mat-option>
      <mat-option *ngIf="loadingProfitCost" disabled>
        Loading...
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
  <div style="flex: 1;" *ngIf="is_requisition">
    <mat-form-field appearance="outline" style="width: auto;">
      <mat-label>Select ERP Code <span style="color: red">*</span></mat-label>
      <mat-select [(ngModel)]="profitcost" placeholder="Select ERP Code"
      (ngModelChange)="fetchSection(profitcost)" [disabled]="isUpdateMode">
        <mat-option *ngFor="let item of filteredProfitCost" [value]="item.id" [disabled]="item.is_active == 0">{{ item.erp_code }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <div style="flex: 1;" *ngIf="is_requisition">
      <mat-form-field appearance="outline" style="width: auto;">
          <mat-label>Select store</mat-label>
          <!-- <mat-select [(ngModel)]="store" (ngModelChange)="onStoreSelect(store)" placeholder="Select Store"
            [disabled]="isUpdateMode"> -->
            <mat-select [(ngModel)]="store" (selectionChange)="onStoreSelect(store)" placeholder="Select Store" [disabled]="isInputDisabled">
            <mat-option *ngFor="let item of store_data" [value]="item.id">{{ item.store_name }}</mat-option>
          </mat-select>
      </mat-form-field>
  </div>

  <div style="flex: 1;" *ngIf="is_requisition">
    <mat-form-field appearance="outline" style="width: auto;">
      <mat-label>Select Section <span style="color: red">*</span></mat-label>
      <!-- <mat-select [(ngModel)]="section" multiple placeholder="Select Section"
        (ngModelChange)="fetchrequisition(store,profitcost,section)" [disabled]="isUpdateMode"> -->
        <mat-select [(ngModel)]="section" multiple placeholder="Select Section"
        (selectionChange)="onSectionChange(section)" [disabled]="isInputDisabled">
        <mat-option *ngFor="let section of section_data" [value]="section.id">{{ section.section_name }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

    <div style="flex: 1;" *ngIf="is_requisition">
      <mat-form-field appearance="outline" style="width: auto;">
        <mat-label>Select Requisition <span style="color: red">*</span></mat-label>
        <!-- <mat-select [(ngModel)]="requisition" multiple placeholder="Select Requisition" (ngModelChange)="requisitiondetials($event)" [disabled]="isUpdateMode"> -->
          <mat-select [(ngModel)]="requisition" multiple placeholder="Select Requisition" (ngModelChange)="requisitiondetials($event)" [disabled]="isInputDisabled">
          <mat-option *ngFor="let item of filteredRequisitions" [value]="item">
            {{ item.req_no }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <!-- <div style="flex: 1;">
      <mat-form-field appearance="outline" style="width: auto;">
        <mat-label>PO No</mat-label>
        <input matInput type="text" [(ngModel)]="po_no" placeholder="po_no" disabled >
      </mat-form-field>
    </div> -->
    <div style="flex: 1;">
      <mat-form-field appearance="outline" style="width: auto;">
        <mat-label>Document Type<span style="color: red">*</span></mat-label>
        <mat-select [(ngModel)]="document_type" [disabled]="isInputDisabled">
          <mat-option *ngFor="let type of documentTypes" [value]="type">
            {{ type }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div style="flex: 1;">
      <mat-form-field appearance="outline" style="width: auto">
        <mat-label>Date <span style="color: red">*</span></mat-label>
        <input type="date" matInput [(ngModel)]="date" class="custom-input" [max]="maxDate" [disabled]="isInputDisabled" (keydown)="preventTyping($event)">
      </mat-form-field>
    </div>
  <!-- <div style="flex: 1;">
  <mat-form-field appearance="outline">
  <mat-label>Contact Person Name</mat-label>
  <mat-select [(ngModel)]="contact_type_id">
    <ng-container *ngFor="let group of groupedContactPersons">
      <mat-optgroup [label]="group.contact_type">
        <mat-option *ngFor="let person of group.items" [value]="person.id">
          {{ person.name }}
        </mat-option>
      </mat-optgroup>
    </ng-container>
  </mat-select>
</mat-form-field>
</div> -->

<div style="flex: 1;">
  <mat-form-field appearance="outline">
    <mat-label>Contact Person Name</mat-label>
    <mat-select [(ngModel)]="selectedContactPersonId" [disabled]="isInputDisabled">
      <mat-option *ngFor="let person of contactPersons" [value]="person.contact_person_id">
        {{ person.contact_person_name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>
  </div>
</app-ui-form-section>

<div class="product-list" *ngIf="!is_reverse && !isView">
  <h4>Requisition List</h4>
  <div class="ui-doc-panel-table-scroll">
  <table class="product-table ui-doc-line-table">
    <thead>
      <tr>
        <th>Select</th>
        <th>Requisition No</th>
        <th>Category</th>
        <th>Item/Service</th>
        <th>Specification</th>
        <th>UOM</th>
        <th>HSN/SAC No</th>
        <th>GST</th>
        <th>Requisition Quantity</th>
        <th>Pending Quantity For PO</th>
        <th>Quantity for PO</th>
        <th>Unit Price</th>
        <th>Start Date</th>
        <th>Requisition Delivery Date</th>
        <th>Expected Delivery Date</th>
      </tr>
    </thead>
    <tbody>
      <!-- <ng-container *ngFor="let product of productList">
        <tr *ngFor="let detail of product.quotationcomparisiondetials; let first = first">
          <td>
            <mat-checkbox [(ngModel)]="detail.selected"></mat-checkbox>
          </td>
          <td>{{ detail.stock_keeping.sku_name }}</td>
          <td>{{ detail.description }}</td>
          <td>{{ detail.unit.unit_name }}</td>
          <td>{{ detail.hsn_no }}</td>
          <td>{{ detail.qty }}</td>
          <td>{{ detail.price }}</td>
          <td>{{ detail.start_date }}</td>
          <td>{{ detail.end_date }}</td>
        </tr>
      </ng-container> -->
      <ng-container *ngFor="let product of productList">
        <ng-container *ngIf="is_qc; else showDetails">
          <tr *ngFor="let detail of product.quotationcomparisiondetials; let first = first">
            <td>
              <mat-checkbox [(ngModel)]="detail.selected" [disabled]="isInputDisabled"></mat-checkbox>
            </td>
            <td>{{ detail.item_service_type === 'SKU' ? detail?.stock_keeping?.item?.item_name : detail?.service?.service_name }}</td>
            <td>{{ detail.description }}</td>
            <td>{{ detail.unit.unit_name }}</td>
            <td>{{ detail.hsn_no }}</td>
            <td>{{ detail.qty }}</td>
            <td>{{ detail.price }}</td>
            <td>{{ detail.start_date }}</td>
            <td>{{ detail.end_date }}</td>
          </tr>
        </ng-container>
      
        <ng-template #showDetails>
          <tr *ngFor="let detail of product.requisitiondetials; let first = first">
            <td>
              <mat-checkbox [(ngModel)]="detail.selected" [disabled]="isInputDisabled"></mat-checkbox>
            </td>
            <td matTooltip="{{product.req_no}}" matTooltipShowDelay="750" >{{ product.req_no }}</td>
            <!-- <td>{{ detail.item_service_type === 'SKU' ? detail?.stock_keeping?.item?.item_name : detail?.service?.service_name }}</td> -->
            <td>
              {{detail.item_service_type === 'SKU'
              ? detail?.stock_keeping?.profit_cost_category?.category?.category_name
              : detail.item_service_type === 'Service'
              ? detail?.service?.profit_cost_category?.category?.category_name
              : detail.item_service_type === 'Fixed Asset'
              ? detail?.fa_template?.home_entity_category?.category_name
              : '' }}</td>
            <td>
              {{
              detail.item_service_type === 'SKU'
              ? detail?.stock_keeping?.item?.item_name
              : detail.item_service_type === 'Service'
              ? detail?.service?.service_name
              : detail.item_service_type === 'Fixed Asset'
              ? detail?.fa_template?.name
              : ''
              }}
            </td>
            <td matTooltip="{{ detail?.specification }}" matTooltipShowDelay="750">{{ detail?.specification }}</td>
            <td matTooltip="{{ detail?.unit?.unit_name }}" matTooltipShowDelay="750">{{ detail?.unit?.unit_name }}</td>
            <td matTooltip="{{ detail?.hsn_no }}" matTooltipShowDelay="750">{{ detail?.hsn_no }}</td>
             <td matTooltip="{{ detail?.hsn_sac?.gst?.gst_percentage }}" matTooltipShowDelay="750">{{ detail?.hsn_sac?.gst?.gst_percentage }}</td>
            <td matTooltip="{{ detail?.qty | number:'1.3-3' }}" matTooltipShowDelay="750">{{ detail?.qty | number:'1.3-3' }}</td>
            <td matTooltip="{{ (detail?.remaining_qty + (skuIdProductsMap?skuIdProductsMap[detail?.sku_id]?.qty:0 || 0)) | number:'1.3-3' }}" matTooltipShowDelay="750">{{ (detail?.remaining_qty + (skuIdProductsMap?skuIdProductsMap[detail?.sku_id]?.qty:0 || 0)) | number:'1.3-3' }}</td>
            <!-- <td><mat-form-field appearance="outline">
              <input matInput type="number" [(ngModel)]="detail.total_qty"  min="0" (keypress)="allowOnlyNumbers($event)" required [disabled]="!detail.selected">
            </mat-form-field></td>  -->
            <td *ngIf="detail.item_service_type !== 'Fixed Asset'; else FA">
              <mat-form-field appearance="outline">
                <input matInput type="number" [(ngModel)]="detail.total_qty" min="0.001" step="0.001"  (keypress)="allowOnlyNumbers($event)" required [disabled]="!detail.selected || isInputDisabled" />
              </mat-form-field>
            </td>
            <ng-template #FA>
              <td>
                <mat-form-field appearance="outline">
                  <input matInput type="number" [(ngModel)]="detail.total_qty" [ngModel]="detail.total_qty || 1" [disabled]="!detail.selected || isInputDisabled" readonly />
                </mat-form-field>
              </td>
            </ng-template>
            <td><mat-form-field appearance="outline">
              <input matInput type="number" [(ngModel)]="detail.price"  min="0.01" step="0.01" (keypress)="allowOnlyNumbers($event)" required [disabled]="!detail.selected || isInputDisabled">
            </mat-form-field></td>
            <td>{{ detail?.start_date }}</td>
            <td>{{ detail?.end_date }}</td>
                <td>
                  <mat-form-field appearance="outline" style="width: auto;">
                    <mat-label>Date <span style="color: red">*</span></mat-label>
                    <input type="date" matInput [(ngModel)]="detail.expected_delivery_date" class="custom-input"  [disabled]="!detail.selected || isInputDisabled" (keydown)="preventTyping($event)">
                  </mat-form-field>
                </td>

          </tr>
        </ng-template>
      </ng-container>
      
    </tbody>
  </table>
  </div>
  <p *ngIf="!productList || productList.length === 0">No item available.</p>
</div>

<div *ngIf="productList.length != 0 && !is_reverse && !isView">
  <mat-form-field appearance="outline" style="width: 20%;margin-top: 20px;">
    <mat-label>Select Label</mat-label>
    <mat-select [(ngModel)]="selectedLabel" placeholder="Select Label" [disabled]="isInputDisabled">
      <mat-option *ngFor="let label of flattenedLabels" [value]="label">
        {{ label }}
      </mat-option>
    </mat-select>
    
  </mat-form-field>
</div>

<button mat-button class="btn btn-success" (click)="detail()" *ngIf="panelMode !== 'view' && !is_reverse">Add Detail Line</button>

<button mat-button class="btn btn-success" (click)="summary()" *ngIf="panelMode !== 'view' && !is_reverse">Add Summary Line</button>

<div style="margin-top: 30px;" *ngIf="!isView">
  <mat-form-field appearance="fill" style="width: 500px;">
    <mat-label>Remark</mat-label>
    <!-- <input matInput [(ngModel)]="remark" placeholder="remark" [disabled]="isUpdateMode"> -->
     <textarea matInput [(ngModel)]="remark" placeholder="remark" rows="3" [disabled]="isInputDisabled"></textarea>
  </mat-form-field>
</div>

<div *ngIf="productList.length != 0">
  <h3>Vendor Branch Details</h3>
  <div style="margin-top: 20px; border: 1px solid #000; padding: 10px;width: 60%">
    <table style="width: 100%; border-collapse: collapse; margin-top: 5px;">
      <tr>
        <td style="width: 50%; padding: 5px;"><strong>Branch Name:</strong>{{ vendordetails?.branch_name || 'NA' }}</td>
        <td style="width: 50%; padding: 5px;"><strong>GST No:</strong>{{ vendordetails?.gst_number || 'NA' }}</td>
      </tr>
      <tr>
        <td style="width: 50%; padding: 5px;"><strong>Email:</strong>{{ vendordetails?.email || 'NA' }}</td>
        <td style="width: 50%; padding: 5px;"><strong>Phone:</strong>{{ vendordetails?.phone || 'NA' }}</td>
      </tr>
      <tr>
        <td style="width: 50%; padding: 5px;"><strong>Address:</strong>{{ vendordetails?.address || 'NA' }}</td>
      </tr>
    </table>
  </div>
</div>

<div *ngIf="productList.length != 0">
  <h3>Selected Products</h3>
  <ul>
    <ng-container *ngFor="let label of labels">
      <li>
        <div style="border: 1px solid black; padding: 10px; margin-bottom: 10px; position: relative;">
          <button mat-icon-button color="warn" (click)="deleteLabelAndProducts(label)" *ngIf="!is_reverse && !isView"
            style="position: absolute; top: 5px; right: 5px;">
            <!-- <mat-icon>delete</mat-icon> -->
            <img src="assets/img/delete.gif" alt="Delete" width="34" height="34">
          </button>
          <strong>Line{{ label.level }}:</strong>
          <mat-form-field appearance="outline" style="width: 80%;">
            <mat-label>Description for Line{{ label.level }}</mat-label>
            <input matInput [(ngModel)]="label.description" placeholder="Enter description" [disabled]="isInputDisabled" />
          </mat-form-field>
            <table style="width: 100%; border-collapse: collapse; margin-top: 10px;" border="1">
              <thead>
                <tr>
                  <th>Category</th>
                  <th>Item/Service</th>
                  <th>Specification</th>
                  <th>Comment</th>
                  <th>UOM</th>
                  <th>HSN/SAC No</th>
                  <th>GST</th>
                  <th>Quantity</th>
                  <th>Unit Price</th>
                  <th>Price</th>
                  <th>Start Date</th>
                  <th>Requisition Delivery Date</th>
                  <th>Expected Delivery Date</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let product of label.products">
                  <td> {{product.item_service_type === 'SKU'
                    ? product?.stock_keeping?.profit_cost_category?.category?.category_name
                    : product.item_service_type === 'Service'
                    ? product?.service?.profit_cost_category?.category?.category_name
                    : product.item_service_type === 'Fixed Asset'
                    ? product?.fa_template?.home_entity_category?.category_name
                    : '' }}</td>
                  <td>{{ product.item_service_type === 'SKU' ? product?.stock_keeping?.item?.item_name : product?.service?.service_name }}</td>
                  <td>{{ product?.specification }}</td>
                  <td>{{ product?.description }}</td>
                  <td>{{ product?.unit?.unit_name }}</td>
                  <td>{{ product?.hsn_no }}</td>
                  <td>{{ product?.hsn_sac?.gst?.gst_percentage }}</td>
                  <td>{{ product?.total_qty | number:'1.3-3'}}</td>
                  <td>{{ product?.unit_price| number: '1.2-2'}}</td>
                  <td>{{ label?.subLabels?.length == 0 ? 0 :(product?.price | number: '1.2-2') }}</td>
                  <td>{{ label?.subLabels?.length == 0 ? '' :(product?.start_date) }}</td>
                  <td>{{ label?.subLabels?.length == 0 ? '' :(product?.end_date) }}</td>
                  <td>{{product?.expected_delivery_date}}</td>
                </tr>
              </tbody>
            </table>
            <ng-container *ngFor="let subLabel of label.subLabels">
              <ng-container *ngTemplateOutlet="renderLabel; context: { $implicit: subLabel }"></ng-container>
            </ng-container>
        </div>
      </li>
    </ng-container>
  </ul>
  <p *ngIf="!labels || labels.length === 0">No item added.</p>
</div>
<ng-template #renderLabel let-subLabel>
  <li style="margin-left: 30px;margin-top: 20px;">
    <strong>Line{{ subLabel.level }}:</strong>
    <div style="display: flex; align-items: center; justify-content: space-between;">
      <div style="display: flex; align-items: center; flex: 1;">
        <mat-form-field appearance="outline" style="width: 80%;">
          <mat-label>Description for Line{{ subLabel.level }}</mat-label>
          <input matInput [(ngModel)]="subLabel.description" placeholder="Enter description" [disabled]="isInputDisabled" />
        </mat-form-field>
      </div>
      <button mat-icon-button color="warn" (click)="deleteSubLabel(subLabel)" *ngIf="!is_reverse && !isView">
        <img src="assets/img/delete.gif" alt="Delete" width="34" height="34">
      </button>
    </div>
    <div style="overflow-x: auto; width: 100%;">
    <table style="width: 100%; border-collapse: collapse; margin-top: 10px;" border="1">
      <thead>
        <tr>
          <th>Category</th>
          <th>Item/Service</th>
          <th>Specification</th>
          <th>Comment</th>
          <th>UOM</th>
          <th>HSN/SAC No</th>
          <th>GST</th>
          <th>Quantity</th>
          <th *ngIf="is_reverse">Reverse Quantity</th>
          <th>Unit Price</th>
          <th>Price</th>
          <th>CGST</th>
          <th>SGST</th>
          <th>IGST</th>
          <th>Start Date</th>
          <th>Requisition Delivery Date</th>
           <th>Expected Delivery Date</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of subLabel.products">
          <!-- <td>{{ product?.item_service_type === 'SKU' ? product?.stock_keeping?.item?.item_name : product?.service?.service_name }}</td> -->
          <td> {{product.item_service_type === 'SKU'
            ? product?.stock_keeping?.profit_cost_category?.category?.category_name
            : product.item_service_type === 'Service'
            ? product?.service?.profit_cost_category?.category?.category_name
            : product.item_service_type === 'Fixed Asset'
            ? product?.fa_template?.home_entity_category?.category_name
            : '' }}</td>
          <td>
            {{
            product.item_service_type === 'SKU'
            ? product?.stock_keeping?.item?.item_name
            : product.item_service_type === 'Service'
            ? product?.service?.service_name
            : product.item_service_type === 'Fixed Asset'
            ? product?.fa_template?.name
            : ''
            }}
          </td>
          <td>{{ product?.specification }}</td>
          <td>{{ product?.description }}</td>
          <td>{{ product?.unit?.unit_name }}</td>
          <td>{{ product?.hsn_no }}</td>
          <td>{{ product?.hsn_sac?.gst?.gst_percentage }}</td>
          <!-- <td>{{ product?.qty }}</td> -->
          <td><mat-form-field appearance="outline">
            <input matInput type="number" [(ngModel)]="product.total_qty" (ngModelChange)="onQtyChange(subLabel,product.total_qty,product.unit_price,product)" min="0.001" step="0.001" (keypress)="allowOnlyNumbers($event)" [disabled]="product.item_service_type === 'Fixed Asset' || is_reverse || isInputDisabled" required>
          </mat-form-field>
          <div *ngIf="data.id && !isView" style="font-size:11px; margin-top:2px;">
                <span *ngIf="product.remaining_qty == 0" style="color:red;">
                  ⛔ Fully dispatched
                </span>
                <span *ngIf="product.remaining_qty != 0" style="color:rgb(255, 123, 0);">
                  ⚠ Already used: {{ (product.qty - product.remaining_qty) | number:'1.3-3' }}
                </span>
              </div>
        </td>
          <td *ngIf="is_reverse"><mat-form-field appearance="outline">
            <input matInput type="number" [(ngModel)]="product.reverse_qty"  min="0.001" step="0.001" (ngModelChange)="onReverseQtyChange(subLabel,product)" (keypress)="allowOnlyNumbers($event)" [disabled]="product.item_service_type === 'Fixed Asset'" required>
          </mat-form-field></td>
          <!-- <td>{{ product?.unit_price}}</td> -->
           <td><mat-form-field appearance="outline">
            <input matInput type="number" [(ngModel)]="product.unit_price" (ngModelChange)="onPriceChange(subLabel,product.total_qty,product.unit_price)" min="0.01" step="0.01" (keypress)="allowOnlyNumbers($event)" [disabled]="is_reverse || isInputDisabled" required>
          </mat-form-field></td>
          <td>{{ product?.price | number: '1.2-2' }}</td>
          <td>{{ cgstAmount(product.total_qty, product.unit_price, product?.hsn_sac?.gst?.gst_percentage) }} ({{ getCGSTPercentage(product?.hsn_sac?.gst?.gst_percentage) }} %)</td>
          <td>{{ sgstAmount(product.total_qty, product.unit_price, product?.hsn_sac?.gst?.gst_percentage) }} ({{ getSGSTPercentage(product?.hsn_sac?.gst?.gst_percentage) }} %)</td>
          <td>{{ igstAmount(product.total_qty, product.unit_price, product?.hsn_sac?.gst?.gst_percentage) }} ({{ getIGSTPercentage(product?.hsn_sac?.gst?.gst_percentage) }} %)</td>
          <td>{{ product?.start_date }}</td>
          <td>{{ product?.end_date }}</td>
          <!-- <td>{{product?.expected_delivery_date}}</td> -->
           <td>
            <mat-form-field appearance="outline" style="width: auto;">
              <mat-label>Date <span style="color: red">*</span></mat-label>
              <input type="date" matInput [(ngModel)]="product.expected_delivery_date" class="custom-input" [disabled]="isInputDisabled" (keydown)="preventTyping($event)">
            </mat-form-field>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
      <ng-container *ngFor="let nestedSubLabel of subLabel.subLabels">
        <ng-container *ngTemplateOutlet="renderLabel; context: { $implicit: nestedSubLabel }"></ng-container>
      </ng-container>
  </li>
</ng-template>

<div class="gst-summary" *ngIf="gstSummary && gstSummary.length > 0">
  <h3 class="gst-title">GST Summary</h3>
  <i class="gst-subtitle">
    (Venodr GST Type: <strong>{{ vendorGstType }}</strong>)
  </i>
  <table class="gst-table">
    <thead>
      <tr>
        <th>GST %</th>
        <th>CGST</th>
        <th>SGST</th>
        <th>IGST</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let gst of gstSummary">
        <td>{{ gst?.gst_percent }}%</td>
        <td>{{ gst?.cgst }}</td>
        <td>{{ gst?.sgst }}</td>
        <td>{{ gst?.igst }}</td>
      </tr>
    </tbody>
  </table>
</div>

  <app-ui-form-section *ngIf="productList.length != 0" title="Terms and Conditions" icon="attach_file">
    <app-ui-document-file-upload
      [disabled]="isInputDisabled"
      [files]="myFiles"
      [showViewLink]="!!data?.id"
      (filesSelected)="onFileSelected($event)"
      (removeFile)="removeFile($event)"
      (viewFiles)="openPoFileShowModal()">
    </app-ui-document-file-upload>
  </app-ui-form-section>

<div *ngIf="calculated_budget && Object.keys(calculated_budget).length > 0" style="margin-top: 30px;">
  <h5><b>Ledger Summary</b></h5>
  <div class="ui-doc-panel-table-scroll">
  <table class="product-table ui-doc-line-table">
    <thead>
      <tr>
        <th>Category Name</th>
        <!-- <th>Ledger Name</th> -->
        <th>Total Budget</th>
        <th>Open Requisition</th>
        <th>Requisition Pending For Approval</th>
        <th>Requisition Approved</th>
        <th>Current PO</th>
        <th>Balance</th>
        <th>Open Purchase Order</th>
        <th>PO Pending for Approval</th>
        <th>PO Approved</th>
        <th>Available Budget After PO</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let category of Object.keys(calculated_budget); let i = index">
        <td>{{ calculated_budget[category]?.category_name || category || 'Unknown' }}</td>
        <!-- <td>{{ ledger.ledger_name || 'Unknown' }}</td> -->
        <td><b>{{ calculated_budget[category]?.total_budget || 0 | number:'1.2-2' }}</b></td>
        <td>{{ calculated_budget[category]?.open_requisition || 0 | number:'1.2-2' }}</td> 
        <td>{{ calculated_budget[category]?.requisition_pending_for_approval || 0 | number:'1.2-2' }}</td>
        <td>{{ calculated_budget[category]?.requisition_approved || 0 | number:'1.2-2' }}</td>
        <td><b>{{ calculated_budget[category]?.current_requisition || 0 | number:'1.2-2' }}</b></td>
        <td><b>{{ calculated_budget[category]?.balance || 0 | number:'1.2-2' }}</b></td>
        <td>{{ calculated_budget[category]?.open_purchase_order || 0 | number:'1.2-2' }}</td>
        <td>{{ calculated_budget[category]?.po_pending_for_approval || 0 | number:'1.2-2' }}</td>
        <td>{{ calculated_budget[category]?.po_approved || 0 | number:'1.2-2' }}</td>
        <td><b>{{ calculated_budget[category]?.available_budget_after_po || 0 | number:'1.2-2' }}</b></td>

      </tr>
    </tbody>
  </table>
  </div>
</div>

<app-ui-document-panel-footer
  [primaryActions]="footerPrimaryActions"
  [secondaryActions]="footerSecondaryActions"
  [destructiveAction]="footerDestructiveAction"
  [overflowActions]="footerOverflowActions"
  (actionClick)="onFooterAction($event)">
</app-ui-document-panel-footer>

</app-ui-document-panel-shell>